import { Mail, MessageCircle, Phone } from "lucide-react";
import { fdate } from "./crmUtil";

const TAG = { VIP: "bg-amber-100 text-amber-800 border-amber-200", New: "bg-emerald-100 text-emerald-800 border-emerald-200",
  Inactive: "bg-slate-100 text-slate-600 border-slate-200" };

export const Tag = ({ t, auto }) => (
  <span className={`rounded-full border px-2 py-0.5 text-[11px] font-semibold ${TAG[t] || "bg-sky-50 text-sky-700 border-sky-200"} ${auto ? "border-dashed" : ""}`}
    title={auto ? "Set automatically from orders" : ""} data-testid={`crm-tag-${t}`}>{t}</span>
);

export const Tags = ({ c }) => c.tags.map((t) => <Tag key={t} t={t} auto={c.auto_tags?.includes(t)} />);

export const RefillPill = ({ r }) => {
  if (!r) return <span className="text-xs text-slate-400">—</span>;
  const cls = r.days < 0 ? "bg-rose-600 text-white" : r.days <= 7 ? "bg-rose-100 text-rose-700" : "bg-slate-100 text-slate-600";
  return <span className={`shrink-0 rounded-full px-2 py-0.5 text-[11px] font-semibold ${cls}`} data-testid="crm-refill-pill">{r.days < 0 ? `Overdue ${-r.days}d` : r.days <= 7 ? `Refill in ${r.days}d` : fdate(r.due)}</span>;
};

export const Initials = ({ name, size = "h-10 w-10 text-sm", onDark }) => (
  <div className={`grid shrink-0 place-items-center rounded-full font-bold ${onDark ? "bg-teal-500 text-white" : "bg-[#0f1c2e] text-teal-300"} ${size}`}>
    {String(name || "?").split(" ").filter(Boolean).map((w) => w[0]).slice(0, 2).join("").toUpperCase()}</div>
);

export const waLink = (num, text) => `https://wa.me/${String(num).replace(/\D/g, "")}?text=${encodeURIComponent(text || "")}`;

export const ContactButtons = ({ c, compact, onTemplate }) => {
  const base = compact ? "rounded-lg p-1.5" : "inline-flex items-center gap-1.5 rounded-lg px-3 py-2 text-xs font-semibold";
  const off = "pointer-events-none opacity-30";
  const wa = c.whatsapp || c.phone;
  return (
    <div className="flex flex-wrap gap-1.5">
      <a href={wa ? waLink(wa) : undefined} target="_blank" rel="noreferrer" title={wa ? "WhatsApp" : "Add a WhatsApp number first"} className={`${base} bg-[#25D366] text-white transition-transform hover:-translate-y-0.5 ${wa ? "" : off}`} data-testid={`crm-contact-whatsapp-btn-${c.key}`}><MessageCircle className="h-4 w-4" />{!compact && "WhatsApp"}</a>
      <a href={c.phone ? `tel:${c.phone.replace(/\s/g, "")}` : undefined} title="Call" className={`${base} border bg-white text-slate-700 transition-transform hover:-translate-y-0.5 ${c.phone ? "" : off}`} data-testid={`crm-contact-call-btn-${c.key}`}><Phone className="h-4 w-4" />{!compact && "Call"}</a>
      <a href={c.email ? `mailto:${c.email}` : undefined} title="Email" className={`${base} border bg-white text-slate-700 transition-transform hover:-translate-y-0.5 ${c.email ? "" : off}`} data-testid={`crm-contact-email-btn-${c.key}`}><Mail className="h-4 w-4" />{!compact && "Email"}</a>
      {!compact && onTemplate && <button onClick={onTemplate} className={`${base} border border-teal-200 bg-teal-50 text-teal-800 hover:bg-teal-100`} data-testid="crm-template-selector-btn">Message templates</button>}
    </div>
  );
};
